import ERPExportVideoModal from './ERP-export-video-modal.vue'
export default ERPExportVideoModal
